/**
 * Created by r4zi4l on 28.05.2021
 */

const PassLastChanceWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;
        this.price = this.calcPrice();

        this._super({
            name: "battlepasslastchancewindow",
            title: Messages.get("PassLastChanceWindow.title"),
            content: this.createContent(),
            buttons: this.createButtons(),
            notCloseByTouchInShadow: true,
            closeButtonDelay: true
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.PassLastChanceWindow;

        const upperText = cleverapps.UI.generateOnlyText(
            Messages.get("PassLastChanceWindow.upperText"),
            cleverapps.styles.FONTS.DARK_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT
        );
        upperText.setAnchorPoint(0.5, 0.5);
        upperText.setDimensions(styles.texts.width, 0);
        upperText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const rewards = this.createRewards();
        rewards.setLocalZOrder(1);

        const lowerText = cleverapps.UI.generateOnlyText(
            Messages.get("PassLastChanceWindow.lowerText"),
            cleverapps.styles.FONTS.DARK_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT
        );
        lowerText.setAnchorPoint(0.5, 0.5);
        lowerText.setDimensions(styles.texts.width, 0);
        lowerText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const content = new cleverapps.Layout([upperText, rewards, lowerText], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        return content;
    },

    createRewards: function () {
        const styles = cleverapps.styles.PassLastChanceWindow.rewards;

        const icons = [this.createReward(false)];
        if (this.mission.logic.hasPremium()) {
            icons.push(this.createReward(true));
        }

        icons[icons.length - 1].addChild(this.createOfferBadge());

        return new cleverapps.Layout(icons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    createOfferBadge: function () {
        const styles = cleverapps.styles.PassLastChanceWindow;

        const badge = new TileBadge({
            text: Messages.get("PassLastChanceWindow.badgeText").replace(/ /g, "\n"),
            rotation: styles.offerBadge.rotation
        });
        badge.setAlignment(styles.offerBadge);
        return badge;
    },

    createButtons: function () {
        const styles = cleverapps.styles.PassLastChanceWindow.buttons;

        const buyButton = this.buyButton = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: this.getProduct().getCurrentPrice(),
            onClicked: function () {
                this.getProduct().buy((success) => {
                    if (success) {
                        this.buyReward();
                    } else {
                        this.buyButton.setString(this.getProduct().getCurrentPrice());
                    }
                });
            }.bind(this),
            type: cleverapps.styles.UI.Button.Images.button_blue
        });

        return [buyButton];
    },

    createReward: function (premium) {
        const styles = cleverapps.styles.PassLastChanceWindow.rewards;

        const background = cleverapps.UI.createScale9Sprite(bundles.passlastchance_window.frames.icon_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setAnchorPoint(0.5, 0.5);
        background.setContentSize2(styles.background);

        const icon = new PassRewardIcon({
            passLogic: this.mission.logic,
            level: this.mission.logic.levels[this.mission.logic.shownProgress.level].level,
            premium
        });
        icon.setScale(1.3);
        icon.setAnchorPoint(0.5, 0.5);
        icon.setAlignment(styles.icon);
        background.addChild(icon);

        if (premium) {
            const ribbon = new cc.Sprite(bundles.passlastchance_window.frames.icon_ribbon);
            ribbon.setAlignment(styles.ribbon);
            background.addChild(ribbon);

            const text = cleverapps.UI.generateOnlyText(Messages.get("PassRewardIcon.ribbonText"), cleverapps.styles.FONTS.BP_LAST_CHANCE_RIBBON);
            text.setAlignment(styles.text);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.setDimensions(styles.text.width, 0);
            text.fitTo(undefined, styles.text.height);
            text.setRotation(styles.text.rotation);
            ribbon.addChild(text);

            if (cleverapps.config.ui !== "heroes") {
                const ticket = new cleverapps.Spine(this.mission.logic.getTicketJson());
                ticket.setAnimation(0, "animation", true);
                ticket.setAnchorPoint(0.5, 0.5);
                ticket.setScale(styles.ticket.scale);
                ticket.setAlignment(styles.ticket);
                background.addChild(ticket);
            }
        }

        return background;
    },

    calcPrice: function () {
        return 100;
    },

    getProduct: function () {
        return Product.CreateByHardPrice(this.calcPrice(), {
            type: "last_chance"
        });
    },

    buyReward: function () {
        this.mission.logic.completeCurrentTask();
        this.close();

        cleverapps.focusManager.display({
            focus: `LastChanceReward${this.mission.name}`,
            stack: true,
            action: (f) => {
                const View = this.mission.getViewClass();
                new View(this.mission);

                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    listBundles: function () {
        return ["passlastchance_window"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BP_LAST_CHANCE_RIBBON: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.PassLastChanceWindow = {
    margin: 40,

    texts: {
        width: 800
    },

    buttons: {
        width: 300,
        height: 110
    },

    offerBadge: {
        x: { align: "right", dx: 50 },
        y: { align: "top", dy: 50 },
        rotation: 15
    },

    rewards: {
        margin: 30,

        background: {
            width: 416,
            height: 416
        },

        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 10 }
        },

        ribbon: {
            x: { align: "left", dx: 1 },
            y: { align: "top", dy: 4 }
        },

        text: {
            x: { align: "center", dx: -26 },
            y: { align: "center", dy: 36 },
            width: 120,
            height: 74,
            rotation: -45
        },

        ticket: {
            x: { align: "right", dx: 109 },
            y: { align: "bottom", dy: -100 },
            scale: 1.3
        }
    }
};
